<template>
  <div class="c-filter">
    <ElForm label-width="80" inline class="elementui-common-form-styles" v-highlight>
      <ElFormItem class="g-pull-right">
        <DatePick v-model="datetime" @change="search" style="width: 220px" :clearable="false"></DatePick>
      </ElFormItem>
      <ElFormItem>
        <ElInput v-model.trim="keyword" :placeholder="placeholder" style="width: 220px" @keyup.enter.native="search">
          <i slot="append" @click="search" class="el-icon-search"></i>
        </ElInput>
      </ElFormItem>
      <ElFormItem label="账号">
        <auto-complete :data="accountData" :width="120" v-model="accountId" placeholder="全部" @on-select="handleAccount"></auto-complete>
      </ElFormItem>
      <ElFormItem v-if="agent" label="投放人员">
        <auto-complete :data="agentData" :width="120" v-model="agentId" placeholder="全部" @on-select="handleAgent"></auto-complete>
      </ElFormItem>
      <ElFormItem v-if="game" label="游戏">
        <auto-complete :data="gameData" v-model="gameId" placeholder="全部" @on-select="handleGame"></auto-complete>
      </ElFormItem>
      <ElFormItem v-if="pricing" label="出价方式">
        <ElSelect v-model="bidMode" style="width: 80px">
          <el-option :value="-1" label="不限"></el-option>
          <el-option value="OCPM" label="OCPM"></el-option>
          <el-option value="OCPC" label="OCPC"></el-option>
          <el-option value="OCPA" label="OCPA"></el-option>
          <el-option value="CPC" label="CPC"></el-option>
          <el-option value="CPM" label="CPM"></el-option>
        </ElSelect>
      </ElFormItem>
      <ElFormItem v-if="inventory" label="流量位置">
        <ElSelect style="width: 180px" v-model="inventoryType">
          <el-option :value="-1" label="不限"></el-option>
          <el-option v-for="(b, i) in invenType" :key="i" :value="b.key" :label="b.value"></el-option>
        </ElSelect>
      </ElFormItem>
      <ElFormItem v-if="rule" label="自动化规则">
        <ElSelect style="width: 70px" v-model="isAutoRule">
          <el-option :value="-1" label="不限"></el-option>
          <el-option :value="0" label="无规则"></el-option>
          <el-option :value="1" label="有规则"></el-option>
        </ElSelect>
      </ElFormItem>
      <ElFormItem label="状态">
        <ElSelect style="width: 120px" v-model="state" transfer>
          <el-option v-for="option in states" :value="option.value" :label="option.label" :key="option.id"></el-option>
        </ElSelect>
      </ElFormItem>
      <ElFormItem v-if="promoted" label="推广对象">
        <ElSelect style="width: 180px" v-model="objectType" transfer>
          <el-option :value="-1" label="不限"></el-option>
          <el-option :value="1" label="网站"></el-option>
          <el-option :value="2" label="iOS应用"></el-option>
          <el-option :value="3" label="安卓应用"></el-option>
        </ElSelect>
      </ElFormItem>
    </ElForm>
  </div>
</template>
<script>
import { adAccount, adPtom, adGames } from '@/api/common.model'
import { formatDate, trim } from '@/common/js/utils'
import AutoComplete from '@/components/autocomplete/autocomplete.vue'
import DatePick from '@/components/date-range-picker/index.vue'
export default {
  name: 'ifilter',
  components: { AutoComplete, DatePick },
  props: {
    states: {
      type: Array
    },
    game: {
      type: Boolean,
      default() {
        return false
      }
    },
    agent: {
      type: Boolean,
      default() {
        return false
      }
    },
    pricing: {
      type: Boolean,
      default() {
        return false
      }
    },
    inventory: {
      type: Boolean,
      default() {
        return false
      }
    },
    billing: {
      type: Array
    },
    invenType: {
      type: Array
    },
    rule: {
      type: Boolean,
      default() {
        return false
      }
    },
    promoted: {
      type: Boolean,
      default() {
        return false
      }
    },
    placeholder: {
      type: String
    }
  },
  methods: {
    sendEvent() {
      let params = {
        queryBeginTime: this.datetime[0],
        queryEndTime: this.datetime[1],
        adAccountId: this.accountId === '' ? undefined : this.accountId,
        gameId: this.gameId === '' ? undefined : this.gameId,
        opId: this.agentId === '' ? undefined : this.agentId,
        bidMode: this.bidMode === -1 ? undefined : this.bidMode,
        inventoryType: this.inventoryType === -1 ? undefined : this.inventoryType,
        isAutoRule: this.isAutoRule === -1 ? undefined : this.isAutoRule,
        status: this.state === -1 ? undefined : this.state,
        objectType: this.objectType === -1 ? undefined : this.objectType
      }
      if (!params.queryBeginTime || !params.queryEndTime) {
        this.$Message.error({
          duration: 5,
          content: '请选择查询日期范围'
        })
        return
      }
      params = Object.assign(params, { keyWord: trim(this.keyword) === '' ? undefined : trim(this.keyword) })
      this.$emit('on-change', params)
    },
    search() {
      const [queryBeginTime, queryEndTime] = this.datetime || ['', '']
      let params = {
        queryBeginTime,
        queryEndTime,
        adAccountId: this.accountId === '' ? undefined : this.accountId,
        gameId: this.gameId === '' ? undefined : this.gameId,
        opId: this.agentId === '' ? undefined : this.agentId,
        bidMode: this.bidMode === -1 ? undefined : this.bidMode,
        inventoryType: this.inventoryType === -1 ? undefined : this.inventoryType,
        isAutoRule: this.isAutoRule === -1 ? undefined : this.isAutoRule,
        status: this.state === -1 ? undefined : this.state,
        objectType: this.objectType === -1 ? undefined : this.objectType
      }
      if (!params.queryBeginTime || !params.queryEndTime) {
        this.$Message.error({
          duration: 5,
          content: '请选择查询日期范围'
        })
        return
      }
      params = Object.assign(params, { keyWord: trim(this.keyword) === '' ? undefined : trim(this.keyword) })
      this.$emit('on-search', params)
    },
    handleAccount(meta) {
      this.accountId = meta.id
    },
    handleAgent(meta) {
      this.agentId = meta.id
    },
    handleGame(meta) {
      this.gameId = meta.id
    }
  },
  watch: {
    comDate(nVal) {
      this.sendEvent()
    }
  },
  data() {
    return {
      state: -1,
      bidMode: -1, // 出价方式
      inventoryType: -1, // 流量位置
      isAutoRule: -1, // 自动化规则
      objectType: -1,
      keyword: '', // 关键词
      datetime: [],
      comDate: [],

      gameData: [], // 游戏
      gameId: '',
      agentData: [], // 投放人员
      agentId: '',
      accountData: [], // 账号
      accountId: ''
    }
  },
  created() {
    const now = formatDate(new Date(), 'yyyy-MM-dd')
    this.datetime = [now, now]
    this.comDate = [now, now]

    // 打包全成功才成功
    Promise.all([
      adAccount({
        mediaId: this.$route.params.id,
        authFlag: 1
      }),
      adPtom({
        authFlag: 1
      }),
      adGames({
        type: 1
      })
    ])
      .then((data) => {
        let [accessData, ptomData, gameData] = data
        if (ptomData && ptomData.length) {
          ptomData = ptomData.map((ret) => {
            ret.id = ret.opId
            return ret
          })
        }
        accessData && (this.accountData = accessData)
        ptomData && (this.agentData = ptomData)
        gameData && (this.gameData = gameData)
      })
      .catch((error) => {
        this.$Message.error({
          duration: 5,
          content: error
        })
      })
  }
}
</script>
